// import { useState, useEffect } from "react";
import { Typography } from "@mui/material";

import { ReactComponent as CheckIcon } from "../../assets/img/check.svg";
import { ReactComponent as CrossIcon } from "../../assets/img/cross.svg";

const PasswordChecklist = ({ password, confirmPassword }) => {
  const checklist = {
    min: {
      valid: password.length >= 8,
      message: "8 caractères minimum",
    },
    specialChars: {
      valid: /^(?=.*[!@#\$%\^&\*])/g.test(password),
      message: "Caractère spécial",
    },
    alphanumeric: {
      valid: /^(?=.*[0-9])/g.test(password),
      message: "Alphanumérique",
    },
    capital: {
      valid: /^(?=.*[A-Z])/g.test(password),
      message: "Lettre majuscule",
    },
  };

  return (
    <div>
      {Object.entries(checklist).map(([key, check]) => (
        <div className="flex items-center text-sm" key={key}>
          <span className={"block mr-2"}>
            {check.valid ? <CheckIcon /> : <CrossIcon />}
          </span>
          <Typography fontSize={14} color={check.valid ? "" : "red"}>
            {check.message}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default PasswordChecklist;
